export const Options = {
    SalutationGerman: [
        { text: "Männlich", value: "m" },
        { text: "Weiblich", value: "w" },
        { text: "Divers", value: "d" },
        { text: "Keine Angabe", value: "k" },
    ],
    SalutationEnglish: [
        { text: "Male", value: "m" },
        { text: "Female", value: "w" },
        { text: "Diverse", value: "d" },
        { text: "Not applicable", value: "k" },
    ],
    BecomingAwareThroughPermanentEmployeesGerman: [
        { text:"Indeed",                              value:"Indeed"},                              
        { text:"Jobware",                             value:"Jobware"},                             
        { text:"LinkedIn",                            value:"LinkedIn"},                            
        { text:"Stepstone",                           value:"Stepstone"},                           
        { text:"XING",                                value:"XING"},                                
        { text:"Andere Stellenbörse",                 value:"Andere Stellenbörse"},                 
        { text:"Lokale Werbemaßnahmen",               value:"Lokale Werbemaßnahmen"},               
        { text:"Karrieremesse",                       value:"Karrieremesse"},                       
        { text:"Produktmesse",                        value:"Produktmesse"},                        
        { text:"Freunde/Familie/Bekannte",            value:"Freunde/Familie/Bekannte"},            
        { text:"Ich arbeite bereits bei dSPACE",      value:"Ich arbeite bereits bei dSPACE"},      
        { text:"dSPACE Produkte",                     value:"dSPACE Produkte"},                     
        { text:"Sonstiges",                           value:"Sonstiges"},                           
    ],
    BecomingAwareThroughPermanentEmployeesEnglish: [
        { text:"Indeed",                              value:"Indeed"},                              
        { text:"Jobware",                             value:"Jobware"},                             
        { text:"LinkedIn",                            value:"LinkedIn"},                            
        { text:"Stepstone",                           value:"Stepstone"},                           
        { text:"XING",                                value:"XING"},                                
        { text:"Other jobboards",                     value:"Andere Stellenbörse"},                 
        { text:"Local advertising",                   value:"Lokale Werbemaßnahmen"},               
        { text:"Career fairs",                        value:"Karrieremesse"},                       
        { text:"Product fairs",                       value:"Produktmesse"},                        
        { text:"Family and friends",                  value:"Freunde/Familie/Bekannte"},            
        { text:"I currently work at dSPACE",          value:"Ich arbeite bereits bei dSPACE"},      
        { text:"dSPACE products",                     value:"dSPACE Produkte"},                     
        { text:"Other",                               value:"Sonstiges"},                           
    ],
    BecomingAwareThroughStudentGerman: [
        { text:"LinkedIn",                            value:"LinkedIn"},                            
        { text:"AStA Jobbörse",                       value:"AStA Jobbörse"},                       
        { text:"Kleinanzeigen",                       value:"Kleinanzeigen"},                       
        { text:"Andere Stellenbörse",                 value:"Andere Stellenbörse"},                 
        { text:"Karrieremesse",                       value:"Karrieremesse"},                       
        { text:"Lokale Werbemaßnahmen",               value:"Lokale Werbemaßnahmen"},               
        { text:"Freunde/Familie/Bekannte",            value:"Freunde/Familie/Bekannte"},            
        { text:"dSPACE Produkte",                     value:"dSPACE Produkte"},                     
        { text:"Campus App",                          value:"Campus App"},                          
        { text:"Sonstiges",                           value:"Sonstiges"},                           
    ],
    BecomingAwareThroughStudentEnglish: [
        { text:"LinkedIn",                            value:"LinkedIn"},                            
        { text:"Asta jobboard",                       value:"AStA Jobbörse"},                       
        { text:"Kleinanzeigen",                       value:"Kleinanzeigen"},                       
        { text:"Other jobboards",                     value:"Andere Stellenbörse"},                 
        { text:"Career fairs",                        value:"Karrieremesse"},                       
        { text:"Local advertising",                   value:"Lokale Werbemaßnahmen"},               
        { text:"Family and friends",                  value:"Freunde/Familie/Bekannte"},            
        { text:"dSPACE products",                     value:"dSPACE Produkte"},                     
        { text:"Campus App",                          value:"Campus App"},                          
        { text:"Other",                               value:"Sonstiges"},                           
    ],
    BecomingAwareThroughAzubiSchuelerGerman: [
        { text:"Ausbildung.de",                       value:"Ausbildung.de"},                       
        { text:"AUBI-plus",                           value:"AUBI-plus"},                           
        { text:"Weitere Ausbildungsportale",          value:"Weitere Ausbildungsportale"},          
        { text:"Ausbildungs- und Studienmessen",      value:"Ausbildungs- und Studienmessen"},      
        { text:"Lokale Werbemaßnahmen",               value:"Lokale Werbemaßnahmen"},               
        { text:"Social Media",                        value:"Social Media"},                        
        { text:"Schulkooperationen /-veranstaltungen",value:"Schulkooperationen /-veranstaltungen"},
        { text:"Freunde/Familie/Bekannte",            value:"Freunde/Familie/Bekannte"},            
        { text:"Sonstiges",                           value:"Sonstiges"},                           
    ],
    BecomingAwareThroughAzubiSchuelerEnglish: [
        { text:"Ausbildung.de",                       value:"Ausbildung.de"},                       
        { text:"AUBI-plus",                           value:"AUBI-plus"},                           
        { text:"Other jobboards",                     value:"Weitere Ausbildungsportale"},          
        { text:"Apprenticeship and study fairs",      value:"Ausbildungs- und Studienmessen"},      
        { text:"Local advertising",                   value:"Lokale Werbemaßnahmen"},               
        { text:"Social Media",                        value:"Social Media"},                        
        { text:"School cooperations / events",        value:"Schulkooperationen /-veranstaltungen"},
        { text:"Family and friends",                  value:"Freunde/Familie/Bekannte"},            
        { text:"Other",                               value:"Sonstiges"},                           
    ],
}
